// Mock data for Copy Compass (frontend-only)

export const LINKS = {
  requestInfo: "#request-info",
  discord: "https://discord.gg/ZcWNNYTTp",
  telegram: "https://t.me/+F1HH-rOtoWhkNTQ0",
  myfxbook: "https://www.myfxbook.com/members/SonicExperts/sonic-ai/12076857",
};

export const NAV_ITEMS = [
  { label: "How It Works", href: "#process" },
  { label: "Results", href: "#results" },
  { label: "FAQ", href: "#faq" },
];

export const HERO = {
  badge: "Fully Automated Trading",
  titleTop: "A clear way to understand automated copy trading.",
  titleBottom: "One strategy. Your account. Copied automatically.",
  subtitle:
    "A short walkthrough of how the setup works, what the verified results show, and what the risks are — before you connect anything.",
  videoThumb:
    "https://images.pexels.com/photos/5831260/pexels-photo-5831260.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  youtubeId: "dQw4w9WgXcQ",
  tags: ["No Courses", "No Signal Groups", "Plug & Play Automation", "Expert-Led Trading"],
};

export const PROCESS = {
  label: "How it works",
  title: "Choose how you want to learn.",
  subtitle:
    "From joining the free community to activating the automated trading setup, the entire onboarding process is simple and fully guided.",
  cards: [
    {
      num: "01",
      tag: "Recommended",
      title: "Request More Information",
      body:
        "Leave your name and a number and you'll get a direct message with the full strategy breakdown, the account structures and the date of the next live session. No personalised investment advice is provided.",
      cta: { label: "Explore the specifics", href: "#request-info", primary: true },
    },
    {
      num: "02",
      tag: null,
      title: "Join the Free Discord Community",
      body:
        "Prefer to explore at your own pace? Join our free Discord community for updates, educational content, daily results, and information breakdown.",
      cta: { label: "Join the Discord", href: "https://discord.gg/ZcWNNYTTp", primary: false },
    },
    {
      num: null,
      tag: "Next Step",
      title: "Activate & Monitor",
      body:
        "Once your account setup is complete, trades from a professional trading team with 15 years of forex experience are automatically replicated in your account. Monitor all trading activity directly while remaining fully in control.",
      cta: null,
    },
  ],
};

export const AUDIENCE = {
  label: "Who it's for",
  title: "Built for People Who Want a More Hands-Off Way to Trade.",
  subtitlePos:
    "Designed for people who want a guided, automated approach while maintaining access to their own trading account.",
  subtitleNeg:
    "Not designed for anyone looking for guaranteed returns, risk-free profits, or overnight results.",
  cards: [
    { num: "01", title: "Busy Schedules", body: "For people who do not have time to monitor charts or place trades manually." },
    { num: "02", title: "New to Automated Copy Trading", body: "No previous trading experience is required. The process explained step by step, so you know exactly what each part of the setup does." },
    { num: "03", title: "Control Still Matters", body: "Monitor all trading activity directly while your account remains in your own name." },
  ],
};

export const RESULTS = {
  label: "Verified results",
  title: "Real Results. Publicly Verifiable.",
  subtitle:
    "Explore the publicly available trading history, performance metrics, win rate, and drawdown through Myfxbook.",
  amplification: 24,
  feePct: 30,
  cards: [
    {
      label: "Average Daily Return (24× Amp., Before 30% Fee)",
      value: "0.96%",
      tone: "positive",
      live: false,
      sub: "0.67% net (after the 30% fee) · 0.04% base at account level",
    },
    {
      label: "Average Monthly Return (24× Amp., Before 30% Fee)",
      value: "27.4%",
      tone: "positive",
      live: false,
      sub: "19.15% net (after the 30% fee) · 1.14% base at account level",
    },
    {
      label: "Max Drawdown (Account Level)",
      value: "0.86%",
      tone: "negative",
      live: false,
      sub: "Unchanged by amplification — see risk note",
    },
    {
      label: "Months in Profit",
      value: "23/23",
      tone: "positive",
      live: false,
      sub: "Positive months since tracking began — verified on Myfxbook",
    },
  ],
  notes: [
    "Returns shown with 24× amplification. Verified on Myfxbook. Maximum drawdown to date is 0.86% measured at account level, which does not change with amplification. Measured against your own deposit it is approximately 20.6% at 24×. Amplified accounts carry a hard broker-side drawdown limit — −5% at 24× and −10% at 12×, measured at account level — and a breach liquidates the account, so your maximum loss is the capital you deposited.",
    "$10 is the minimum account deposit, not a recommended trading allocation. Trading leveraged products involves a high risk of loss, and small balances may be more sensitive to fees, margin requirements and market volatility.",
  ],
  disclaimer: "Past performance does not guarantee future results. Trading involves risk, and capital can be lost.",
  cta: { label: "View Verified Results", href: "https://www.myfxbook.com/members/SonicExperts/sonic-ai/12076857" },
};

export const MEMBERS = {
  label: "Member results",
  title: "Real Accounts. Real Trading Activity.",
  subtitle:
    "See examples from members using the automated trading setup. Individual results vary, and trading involves risk.",
  disclaimer:
    "Results shown reflect individual experiences and are not indicative of what every user will achieve. Past performance is not a reliable indicator of future results. Trading involves significant risk, and you may lose some or all of your trading capital.",
  // Styled mock chat/trade cards (no external images)
  cards: [
    {
      type: "chat",
      name: "Marcus T.",
      messages: [
        { from: "them", text: "Thank you guys! Been withdrawing every week between $500–$1000 profit on my account 🙏" },
        { from: "me", text: "Love to hear it. Consistency is the goal." },
      ],
    },
    {
      type: "trades",
      name: "XAUUSD Activity",
      account: { starting: "2,976.70", drawdown: "-66.99", current: "20,052.35" },
      trades: [
        { pair: "XAUUSD", side: "sell", price: "2.141389", pl: "830.86" },
        { pair: "XAUUSD", side: "buy", price: "2.167356", pl: "1,231.06" },
        { pair: "XAUUSD", side: "buy", price: "2.181582", pl: "2,048.51" },
        { pair: "XAUUSD", side: "sell", price: "2.207291", pl: "920.44" },
        { pair: "XAUUSD", side: "buy", price: "2.218505", pl: "654.46" },
        { pair: "XAUUSD", side: "buy", price: "2.226079", pl: "883.75" },
        { pair: "XAUUSD", side: "buy", price: "2.23639", pl: "1,203.18" },
        { pair: "XAUUSD", side: "buy", price: "2.250933", pl: "1,093.95" },
        { pair: "XAUUSD", side: "sell", price: "2.262397", pl: "1,266.94" },
      ],
    },
    {
      type: "chat",
      name: "Sophia R.",
      messages: [
        { from: "them", text: "Life is going well!!! Sky is the limit 🔥" },
        { from: "me", text: "Amazing results! Keep monitoring and stay disciplined." },
      ],
    },
    {
      type: "chat",
      name: "David K.",
      messages: [
        { from: "them", text: "Set everything up in a day, trades are copying automatically now. Super smooth onboarding." },
        { from: "me", text: "Great — remember it stays fully in your own account." },
      ],
    },
  ],
};

export const FAQ_ITEMS = [
  {
    q: "Is this a signal service or trading bot?",
    a: "No. It is an automated copy trading setup. Trades executed by a professional trading team are replicated in your own brokerage account. There are no manual signals to follow and no course to complete.",
  },
  {
    q: "Do I need trading experience?",
    a: "No previous trading experience is required. Further information will inform you on your situation.",
  },
  {
    q: "Can I use an existing trading account?",
    a: "In most cases yes, provided your broker supports copy trading. We walk through the compatible options with you.",
  },
  {
    q: "Are the results guaranteed?",
    a: "No. Trading involves significant risk and capital can be lost. Past performance is not a reliable indicator of future results and no returns are guaranteed.",
  },
  {
    q: "Do I keep control of my account?",
    a: "Yes. The account always remains in your own name. You can monitor all trading activity directly and retain full control at all times.",
  },
  {
    q: "What costs can apply?",
    a: "Costs can include standard broker spreads and any applicable service fees discussed transparently during the live session or info booklet sent over.",
  },
  {
    q: "Is there a minimum starting balance?",
    a: "The minimum deposit is $10. This is the technical minimum for opening and funding an eligible account, not a recommended allocation or a guarantee that every trade can be copied under all market conditions. Only deposit money you can afford to lose.",
  },
  {
    q: "How do I get support?",
    a: "You have 24/7 access to our support team by email and live chat, plus a dedicated community Discord channel where we post market updates and answer questions.",
  },
  {
    q: "What market does the strategy trade?",
    a: "The strategy primarily focuses on gold (XAUUSD) within the forex market, executed by a team with 15 years of experience.",
  },
];

export const REQUEST_INFO = {
  label: "Next step",
  titleTop: "Request More",
  titleBottom: "Information",
  body:
    "Leave your name and a number. You get a direct message with the full strategy breakdown, the account structures and the next live session. I don't give personal advice and can't tell you whether it's right for you.",
  checklist: [
    "The strategy and account-structure breakdown in writing",
    "The date and link for the next live walkthrough session",
    "A straight answer to whatever you want to ask first",
  ],
  sessionsLabel: "Live walkthrough sessions",
  sessions: ["Tuesday", "Thursday", "Sunday"],
  sessionsNote: "English-language sessions",
  experienceNote:
    "No forex experience needed — the account is connected and from that point the strategy does its work automatically.",
  form: {
    nameLabel: "Your Name",
    namePlaceholder: "First and last name",
    phoneLabel: "Phone Number",
    phonePlaceholder: "+1 (555) 000-0000",
    phoneHelper: "Include your country code so the message reaches you.",
    countryLabel: "Country (optional)",
    countryPlaceholder: "Where you are based",
    messageLabel: "Anything you want covered first? (optional)",
    messagePlaceholder: "e.g. how the 12× structure works on a small account",
    consent:
      "I'm happy to be contacted about this by message or phone. No obligation, and I can ask to be removed at any time.",
    submit: "Request More Info",
    successTitle: "Request received",
    successBody:
      "Thanks — your request has been noted. You'll get a direct message with the full strategy breakdown and the next live session details.",
  },
  footnote: "No courses • No signal groups • Complete transparency",
};

export const FOOTER = {
  brand: "Copy Compass",
  operator: "Hunter Ely",
  tagline: "Automated copy trading. Clear information. Transparent results.",
  disclaimer:
    "Educational information only. Trading involves significant risk and is not suitable for everyone. Past performance is not a reliable indicator of future results. Capital can be lost. Nothing on this website constitutes personalised investment advice.",
  copyright: "Copy Compass",
};

export const LEGAL = {
  privacy: {
    title: "Privacy Policy",
    updated: "Last updated: September 2026",
    sections: [
      {
        h: "1. Overview",
        p: "This Privacy Policy explains how Hunter Ely (\u201cwe\u201d, \u201cus\u201d, \u201cCopy Compass\u201d) collects, uses and protects the information you provide when you visit this website or contact us. By using the site you agree to the practices described here.",
      },
      {
        h: "2. Information We Collect",
        p: "We may collect information you voluntarily provide, such as your name, email address and any details shared when booking a call or joining our community. We may also collect basic technical data such as browser type, device and general usage analytics to improve the site.",
      },
      {
        h: "3. How We Use Your Information",
        p: "Information is used to respond to enquiries, arrange informational calls, provide educational updates you have requested, and maintain and improve the website. We do not sell your personal information to third parties.",
      },
      {
        h: "4. Third-Party Services",
        p: "We use trusted third-party tools (for example scheduling, messaging and analytics providers) that process limited data on our behalf. These providers are responsible for their own privacy practices, which we encourage you to review.",
      },
      {
        h: "5. Data Retention & Security",
        p: "We retain personal information only as long as necessary for the purposes described above and apply reasonable safeguards to protect it. No method of transmission or storage is completely secure, and we cannot guarantee absolute security.",
      },
      {
        h: "6. Your Rights",
        p: "You may request access to, correction of, or deletion of your personal information at any time by contacting us. You can also opt out of non-essential communications whenever you wish.",
      },
      {
        h: "7. Contact",
        p: "For any privacy questions or requests, please reach out through the contact options provided on this website.",
      },
    ],
  },
  terms: {
    title: "Terms of Service",
    updated: "Last updated: September 2026",
    sections: [
      {
        h: "1. Acceptance of Terms",
        p: "By accessing this website operated by Hunter Ely, you agree to these Terms of Service. If you do not agree, please do not use the site.",
      },
      {
        h: "2. Nature of the Service",
        p: "This website provides general information and educational content about an automated copy trading setup. It is not a broker, does not hold client funds, and does not provide personalised investment, legal or tax advice.",
      },
      {
        h: "3. No Guarantees",
        p: "Nothing on this site is a promise or guarantee of any particular result. Trading involves substantial risk and you may lose some or all of your capital. Any performance figures are illustrative and past performance does not guarantee future results.",
      },
      {
        h: "4. Your Responsibilities",
        p: "You are responsible for your own trading decisions and for ensuring that copy trading is legal and suitable for you in your jurisdiction. Your brokerage account remains in your own name and under your control at all times.",
      },
      {
        h: "5. Intellectual Property",
        p: "All content on this website, including text, graphics and branding, is owned by or licensed to Hunter Ely and may not be reproduced without permission.",
      },
      {
        h: "6. Limitation of Liability",
        p: "To the fullest extent permitted by law, Hunter Ely shall not be liable for any losses or damages arising from your use of this website or any trading activity you undertake.",
      },
      {
        h: "7. Changes",
        p: "We may update these Terms from time to time. Continued use of the site after changes are posted constitutes acceptance of the revised Terms.",
      },
    ],
  },
  risk: {
    title: "Risk Disclosure",
    updated: "Last updated: September 2026",
    sections: [
      {
        h: "1. High-Risk Warning",
        p: "Trading foreign exchange and other leveraged products carries a high level of risk and may not be suitable for all investors. Leverage can work against you as well as for you. Before deciding to trade, you should carefully consider your objectives, experience and risk tolerance.",
      },
      {
        h: "2. Possible Loss of Capital",
        p: "You could sustain a loss of some or all of your initial capital. Do not invest money that you cannot afford to lose. If you have any doubts, seek advice from an independent, licensed financial adviser.",
      },
      {
        h: "3. No Advice",
        p: "The information provided by Hunter Ely and this website is for general and educational purposes only and does not constitute personalised investment advice or a recommendation to buy, sell or hold any instrument.",
      },
      {
        h: "4. Past Performance",
        p: "Any results, statistics or examples shown are historical and are not a reliable indicator of future performance. Individual results vary and there is no assurance that you will achieve similar outcomes.",
      },
      {
        h: "5. Automated Copy Trading",
        p: "Automated copy trading replicates the activity of a third-party strategy in your own account. Technical issues, connectivity problems, slippage and market conditions can affect results and are outside our control.",
      },
    ],
  },
  affiliate: {
    title: "Affiliate Disclosure",
    updated: "Last updated: September 2026",
    sections: [
      {
        h: "1. Transparency",
        p: "In the interest of full transparency, Hunter Ely may receive compensation through affiliate or referral arrangements with certain brokers or service providers mentioned on this website.",
      },
      {
        h: "2. How It Works",
        p: "If you open an account or use a service through a link we provide, we may earn a referral fee or rebate at no additional cost to you. This does not influence the information or opinions we share.",
      },
      {
        h: "3. Our Commitment",
        p: "We only reference brokers and tools that are relevant to the automated copy trading setup we describe. Any compensation received does not change your rights, costs or the control you retain over your own account.",
      },
      {
        h: "4. Your Choice",
        p: "You are never obligated to use any recommended provider and are free to choose any compatible broker that suits your needs.",
      },
    ],
  },
};
